import { render, staticRenderFns } from "./BidEdit.vue?vue&type=template&id=1ee01af4"
import script from "./BidEdit.vue?vue&type=script&lang=ts"
export * from "./BidEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports